import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { cloneDeep } from 'lodash';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { getPageTotalCount } from '../../../utils/utils';
import RouteNames from '../../App/RouteNames';
import { DataTable, TablePagination, Breadcrumb } from '../../../components/common';
import PriceOfferSort from '../../../constantsApp/pricingManager/priceOfferSort';
import { makeGetPermissionsPricingManagement } from '../../App/selectors';
import { OfferSearchForm } from '../../../components/PricingHub';
import { makeGetListPriceOffers } from '../selectors';
import { searchPriceOffers, setParamsPriceOffers } from '../actions';
import {
  checkPermissionCeatePriceOffer,
  checkPermissionModifyPriceOffer,
  checkPermissionSearchPriceOffers,
  checkPermissionGetPriceOffer,
} from '../CheckPermission';

class PricingPriceOffer extends Component {
  state = {
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (state && props.listPriceOffers) {
      return {
        totalCount: getPageTotalCount({ ...state, items: props.listPriceOffers }),
      };
    }
    return {};
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && location.state && location.state.filter) {
      this.setState({ filter: location.state.filter }, () => {
        this.doSearchOffers();
      });
    } else {
      this.doSearchOffers();
    }
  }

  onClickRow = e => {
    e.preventDefault();
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doSearchOffers());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doSearchOffers());
  };

  onSubmitSearch = filteredData => {
    this.setState({ filter: filteredData, page: 0 }, () => this.doSearchOffers());
  };

  doSearchOffers = () => {
    const { page, size, sorted, filter } = this.state;
    const { searchPriceOffers } = this.props;
    const newFilter = cloneDeep(filter);
    const sort =
      sorted && sorted.sortCol && sorted.sortDir && PriceOfferSort[sorted.sortCol]
        ? PriceOfferSort[sorted.sortCol][sorted.sortDir]
        : null;
    if (newFilter.isProvisionable) newFilter.isProvisionable = newFilter.isProvisionable === 'TRUE' ? 'true' : 'false';
    this.setState({ isSearching: true });
    const params = {
      page: page + 1,
      size,
      filter: newFilter,
    };
    if (sort) {
      params.sort = sort;
    }
    searchPriceOffers(params, () => {
      this.setState({ isSearching: false, filter, sort });
    });
  };

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => this.doSearchOffers());
  };

  render() {
    const { listPriceOffers, permissionsPricing, t, location } = this.props;
    const { sorted, isSearching, page, size, totalCount, filter } = this.state;
    const tableColumns = [
      {
        name: 'id',
        label: 'common:label.id',
        render: (colName, item) => (
          <Link
            className="text-success"
            to={{
              pathname: RouteNames.prettifyPath(RouteNames.pricingPriceOfferEdit.path, item.id),
              state: { filter },
            }}
          >
            {item.id}
          </Link>
        ),
      },
      {
        name: 'name',
        label: 'common:label.name',
        sortable: true,
        style: { minWidth: '100px' },
      },
      {
        name: 'description',
        label: 'common:label.description',
      },
      {
        name: 'serviceType',
        label: 'common:label.serviceType',
        sortable: true,
        isRenderT: true,
        style: { minWidth: '110px' },
        render: (colName, item, t) => {
          const slt = t ? t('selections:serviceType')().find(val => val.value === item.serviceType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'pricingModel',
        label: 'common:label.pricingModel',
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:pricingModel')().find(val => val.value === item.pricingModel) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'transactionType',
        label: 'common:label.transactionType',
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:transactionType')().find(val => val.value === item.transactionType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
        sortable: true,
        style: { minWidth: '140px' },
      },
      {
        name: 'itemId',
        label: 'common:label.itemId',
      },
      {
        name: 'salesChannel',
        label: 'common:label.salesChannel',
        sortable: true,
        style: { minWidth: '120px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:salesChannel')().find(val => val.value === item.salesChannel) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'marketSegment',
        label: 'common:label.marketSegment',
        sortable: true,
        style: { minWidth: '130px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:marketSegment')().find(val => val.value === item.marketSegment) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'accountType',
        label: 'common:label.accountType',
        sortable: true,
        style: { minWidth: '120px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:accountType')().find(val => val.value === item.accountType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'accountSubType',
        label: 'common:label.accountSubType',
        sortable: true,
        style: { minWidth: '140px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:accountSubType')().find(val => val.value === item.accountSubType) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'serviceAddOn',
        label: 'common:label.serviceAddOn',
      },
      {
        name: 'status',
        label: 'common:label.status',
        sortable: true,
        style: { minWidth: '80px' },
        isRenderT: true,
        render: (colName, item, t) => {
          const slt = t ? t('selections:statusPricing')().find(val => val.value === item.status) : '';
          return <span>{slt ? slt.label : ''}</span>;
        },
      },
      {
        name: 'startDate',
        label: 'common:label.startDate',
        sortable: true,
        style: { minWidth: '90px' },
      },
      {
        name: 'action',
        label: 'common:label.action',
        isRenderT: true,
        render: (colName, item, t) => (
          <Link
            className="btn btn-outline-success btn-sm"
            to={{
              pathname: RouteNames.prettifyPath(RouteNames.pricingPriceOfferEdit.path, item.id),
              state: { filter },
            }}
          >
            {t('label.view')}
          </Link>
        ),
      },
    ];

    const newColumnTable = cloneDeep(tableColumns);
    let modeCreatePriceOffer = 0;
    let modeModifyPriceOffer = 0;
    let modeSearchPriceOffers = 0;
    let modeGetPriceOffer = 0;

    if (permissionsPricing && permissionsPricing.pricingModulePermissions) {
      const listPermissionPricing = permissionsPricing.pricingModulePermissions;
      modeCreatePriceOffer = checkPermissionCeatePriceOffer({ listPermission: listPermissionPricing });
      modeModifyPriceOffer = checkPermissionModifyPriceOffer({ listPermission: listPermissionPricing });
      modeSearchPriceOffers = checkPermissionSearchPriceOffers({ listPermission: listPermissionPricing });
      modeGetPriceOffer = checkPermissionGetPriceOffer({ listPermission: listPermissionPricing });
    }

    if (modeSearchPriceOffers === 0 || modeGetPriceOffer === 0) return '';

    if (modeModifyPriceOffer === 0) {
      newColumnTable[0] = {
        name: 'id',
        label: 'Id',
      };
      newColumnTable.splice(newColumnTable.length - 1, 1);
    }

    const tableConfig = {
      columns: newColumnTable,
      data: listPriceOffers,
      sorted: { ...sorted },
      onSort: this.onSortColumn,
    };
    return (
      <div>
        <div className="page-title">
          <div className="row">
            <div className="col-sm-6">
              <Link
                to={
                  modeCreatePriceOffer !== 2
                    ? RouteNames.productFamilyPricing.path
                    : { pathname: RouteNames.pricingPriceOfferAdd.path, state: { filter } }
                }
                className="button x-small"
              >
                {modeCreatePriceOffer !== 2 ? t('label.back') : t('label.createNewPriceOffer')}
              </Link>
            </div>

            <div className="col-sm-6">
              <Breadcrumb
                items={[
                  { name: t('navbar:pricingHub.subMain.pricingManagement'), url: RouteNames.pricingItem.path },
                  { name: t('pricingPage:sidebar.priceOffer'), url: RouteNames.pricingPriceOffer.path },
                ]}
              />
            </div>
          </div>
        </div>

        <br />
        <div className="col-md-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <div className="repeater-file">
                <div data-repeater-list="group-a">
                  <OfferSearchForm
                    onSubmit={this.onSubmitSearch}
                    isSubmitting={isSearching}
                    defaultFilter={location && location.state && location.state.filter ? location.state.filter : {}}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-sm-12 mb-30">
          <div className="card card-statistics h-100">
            <div className="card-body">
              <DataTable {...tableConfig} onClickRow={this.onClickRow} isLoading={isSearching} />
            </div>
          </div>
        </div>

        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
      </div>
    );
  }
}

PricingPriceOffer.propTypes = {
  listPriceOffers: PropTypes.arrayOf(PropTypes.any),
  searchPriceOffers: PropTypes.func.isRequired,
  permissionsPricing: PropTypes.objectOf(PropTypes.any),
};

PricingPriceOffer.defaultProps = {
  listPriceOffers: [],
  permissionsPricing: {},
};

const mapStateToProps = createStructuredSelector({
  listPriceOffers: makeGetListPriceOffers() || [],
  permissionsPricing: makeGetPermissionsPricingManagement() || {},
});

const newPricingPriceOffer = connect(mapStateToProps, { searchPriceOffers, setParamsPriceOffers })(PricingPriceOffer);

export default withTranslation(['common', 'navbar', 'pricingPage'])(newPricingPriceOffer);
